import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

export interface DashboardPanelProps {
	title?:    ReactNode
	subtitle?: ReactNode
	actions?:  ReactNode
	children:  ReactNode
	className?: string
	contentClassName?: string
	headless?:  boolean
}

/**
 * Общий контейнер дашборд-блока: рамка + заголовок (опц.) + слот для действия
 * (фильтр/кнопка) справа + контент. Все секции главной и карточки интеграций
 * используют его, чтобы оформление было единообразным.
 */
export function DashboardPanel({
	title,
	subtitle,
	actions,
	children,
	className,
	contentClassName,
	headless = false,
}: DashboardPanelProps) {
	return (
		<div
			className={cn(
				'flex flex-col gap-4 rounded-(--radius-lg) border border-(--color-border) bg-(--color-background) p-4',
				className,
			)}
		>
			{!headless && (title || actions || subtitle) && (
				<div className="flex items-start justify-between gap-2">
					<div className="flex flex-col gap-1">
						{title && (
							<h2 className="text-base font-[500] leading-6 text-(--color-foreground)">{title}</h2>
						)}
						{subtitle && (
							<div className="text-sm text-(--color-muted-foreground)">{subtitle}</div>
						)}
					</div>
					{actions}
				</div>
			)}
			<div className={cn('flex flex-col gap-3', contentClassName)}>
				{children}
			</div>
		</div>
	)
}
